import essApi from "../axios/essApi";

class TravelService {
    async GetAlltripType() {
        return Promise.resolve(essApi.get(`trip_type`));
    }
    async GetUserTravelcountHrWise() {
        return Promise.resolve(essApi.get(`travel-Count-Hr`));
    }
    async GetUserTravelcountforCEOandTravel() {
        return Promise.resolve(essApi.get(`travel-Count-All`));
    }
    async GetAllVisaType() {
        return Promise.resolve(essApi.get(`visa_Type`));
    }
    async GetAllDesignation() {
        return Promise.resolve(essApi.get(`designation`));
    }

    async GetAllBusinessUnit() {
        return Promise.resolve(essApi.get(`business-unit`));
    }

    async GetAllCountry() {
        return Promise.resolve(essApi.get(`countries`));
    }
    async createTravelAndDetails(params) {
        return Promise.resolve(essApi.post(`travel_create`,params));
    }

    async getStateByCountryId(countryId) {
        return Promise.resolve(essApi.get(`state/${countryId}`));
    }
    async GetAllDACurrency() {
        return Promise.resolve(essApi.get(`DACurrency`));
    }
    async GetAllocationByUser() {
        return Promise.resolve(essApi.get(`user-allocated_project`));
    }
    async getAllTravelByUser() {
        return Promise.resolve(essApi.get(`user-travel`));
    }
    async GetUserTravelBySuperiorcount() {
        return Promise.resolve(essApi.get(`travel-count`));
    }
    async GetUserTravelcountBuWise() {
        return Promise.resolve(essApi.get(`travel-Count-Bu`));
    }
    async getUserBySuperiorwithTravelRequest() {
        return Promise.resolve(essApi.get(`travel-record_by_superior`));
    }
    async getAlltravelRecordByUserId(param) {
        return Promise.resolve(essApi.get(`travel-record/${param}`));
    }
    async ApproveRejecttravelBulk(param) {
        return Promise.resolve(essApi.post(`approve-reject`,param));
    }
    async GetUserReviewtravelBySuperior() {
        return Promise.resolve(essApi.get(`user-travel-in-review`));
    }
    async getAllTravelRequestBuwiseandsearchByECN(param) {
        return Promise.resolve(essApi.post(`travel_details_bu_wise`,param));
    }
    async GetUserTravelcount() {
        return Promise.resolve(essApi.get(`travel-count_Hr`));
    }
    async getUserTravelDetailsById(id) {
        return Promise.resolve(essApi.get(`travel/getDetails/${id}`));
    }
    async GetAllCustomer() {
        return Promise.resolve(essApi.get(`customers`));
    }
    async getUserReviewtravelByTr() {
        return Promise.resolve(essApi.get('All_user-travel-in-review'));
    }
    async getUserReviewtravelwithAllStatus() {
        return Promise.resolve(essApi.get('travel-status'));
    }
    async updateTravelVisaType(params) {
        return Promise.resolve(essApi.put('updateTravelVisaType', params));
    }
    async markAsTravel(params) {
        return Promise.resolve(essApi.put('mark-as-travel', params));
    }
}
export default TravelService;